<template>
  <v-app>
    <core-app-bar />

    <core-drawer />

    <core-invoice-view />

    <core-footer />

  </v-app>
</template>

<script>
export default {
  name: 'Invoice',
  components: {
    CoreAppBar: () => import('../components/core/AppBar'),
    CoreDrawer: () => import('../components/core/Drawer'),
    CoreInvoiceView: () => import('../components/core/InvoiceView'),
    CoreFooter: () => import('../components/core/Footer'),
  },
  data: () => ({
    expandOnHover: false,
  }),
}
</script>
